"use strict";
exports.__esModule = true;
exports.ERC20Service = void 0;
var tslib_1 = require("tslib");
var alchemy_provider_1 = require("../factory/alchemy-provider");
var bignumber_js_1 = tslib_1.__importDefault(require("bignumber.js"));
var typechain_types_1 = require("../../typechain-types");
var constants_1 = require("@ethersproject/constants");
var chain_provider_1 = require("../factory/chain-provider");
var transaction_service_1 = require("../transaction/transaction.service");
var utils_1 = require("../common/utils");
var gelato_1 = require("../gasless-providers/gelato");
var ERC20Service = /** @class */ (function () {
    function ERC20Service() {
    }
    ERC20Service.listAccountTokens = function (address, chainID) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var alchemyProvider, balances, nonZeroBalances, accountTokens, _i, nonZeroBalances_1, token, balance, metadata, formattedBalance;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        alchemyProvider = (0, alchemy_provider_1.getAlchemyProvider)(chainID);
                        return [4 /*yield*/, alchemyProvider.core.getTokenBalances(address)];
                    case 1:
                        balances = _a.sent();
                        nonZeroBalances = balances.tokenBalances.filter(function (token) {
                            return token.tokenBalance !== "0";
                        });
                        accountTokens = [];
                        _i = 0, nonZeroBalances_1 = nonZeroBalances;
                        _a.label = 2;
                    case 2:
                        if (!(_i < nonZeroBalances_1.length)) return [3 /*break*/, 5];
                        token = nonZeroBalances_1[_i];
                        balance = token.tokenBalance;
                        return [4 /*yield*/, alchemyProvider.core.getTokenMetadata(token.contractAddress)];
                    case 3:
                        metadata = _a.sent();
                        formattedBalance = void 0;
                        if (balance && metadata.decimals) {
                            formattedBalance = new bignumber_js_1["default"](balance).div(Math.pow(10, metadata.decimals));
                            formattedBalance = formattedBalance.toFixed(2);
                        }
                        accountTokens.push({
                            tokenContractAddress: token.contractAddress,
                            tokenName: metadata.name,
                            tokenSymbol: metadata.symbol,
                            rawBalance: balance,
                            formattedBalance: formattedBalance
                        });
                        _a.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5: return [2 /*return*/, accountTokens];
                }
            });
        });
    };
    ERC20Service.getBalance = function (contractAddress, ownerAddress, chainID) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var alchemyProvider, balance, metadata, formattedBalance;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        alchemyProvider = (0, alchemy_provider_1.getAlchemyProvider)(chainID);
                        return [4 /*yield*/, alchemyProvider.core.getTokenBalances(ownerAddress, [
                                contractAddress,
                            ])];
                    case 1:
                        balance = (_a.sent()).tokenBalances[0].tokenBalance;
                        return [4 /*yield*/, alchemyProvider.core.getTokenMetadata(contractAddress)];
                    case 2:
                        metadata = _a.sent();
                        if (balance && metadata.decimals) {
                            formattedBalance = new bignumber_js_1["default"](balance).div(Math.pow(10, metadata.decimals));
                            formattedBalance = formattedBalance.toString();
                        }
                        return [2 /*return*/, {
                                tokenName: metadata.name,
                                tokenSymbol: metadata.symbol,
                                rawBalance: balance,
                                formattedBalance: formattedBalance
                            }];
                }
            });
        });
    };
    ERC20Service.transfer = function (transferRequest, chainId, pkOrProvider, isGasless) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var contractAddress, owner, receiver, amount, contract, _a, _b, _c, tx, preparedTx;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, (0, utils_1.getChainID)(pkOrProvider, chainId)];
                    case 1:
                        chainId = _d.sent();
                        contractAddress = transferRequest.contractAddress, owner = transferRequest.owner, receiver = transferRequest.receiver, amount = transferRequest.amount;
                        _b = (_a = typechain_types_1.ERC20__factory).connect;
                        _c = [constants_1.AddressZero];
                        return [4 /*yield*/, (0, chain_provider_1.getChainProvider)(chainId)];
                    case 2:
                        contract = _b.apply(_a, _c.concat([_d.sent()])).attach(contractAddress);
                        return [4 /*yield*/, contract.populateTransaction.transfer(receiver, amount)];
                    case 3:
                        tx = _d.sent();
                        if (isGasless)
                            return [2 /*return*/, gelato_1.Gelato.sendTx(chainId, contractAddress, owner, tx.data, pkOrProvider)];
                        return [4 /*yield*/, transaction_service_1.TransactionService.prepareTransaction(tslib_1.__assign(tslib_1.__assign({}, tx), { from: owner, chainId: chainId }), chainId)];
                    case 4:
                        preparedTx = _d.sent();
                        return [4 /*yield*/, (0, utils_1.getWallet)(pkOrProvider, chainId)];
                    case 5: return [4 /*yield*/, (_d.sent()).sendTransaction(preparedTx)];
                    case 6: return [2 /*return*/, (_d.sent()).hash];
                }
            });
        });
    };
    return ERC20Service;
}());
exports.ERC20Service = ERC20Service;
